module.exports = __webpack_public_path__ + "img/Caribbean_Meal_Jerk_Chicken.86e8a804.jpg";